import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';

import { XmedicalUiModule } from '@xmedical/ui';
import { PlaybackComponent } from '@xmedical/transcribe';

// Module-based Components
import { AllergyWidgetViewComponent } from './components/allergy-widget-view/allergy-widget-view.component';
import { DiagnosisWidgetViewComponent } from './components/diagnosis-widget-view/diagnosis-widget-view.component';
import { MedicationWidgetViewComponent } from './components/medication-widget-view/medication-widget-view.component';
import { ProblemWidgetViewComponent } from './components/problem-widget-view/problem-widget-view.component';
import { UploadsWidgetViewComponent } from './components/uploads-widget-view/uploads-widget-view.component';
import { ClinicalNotesWidgetViewComponent } from './components/clinical-notes-widget-view/clinical-notes-widget-view.component';
import { ProcedureWidgetViewComponent } from './components/procedure-widget-view/procedure-widget-view.component';

// Standalone Components
import { IncomingReferralCardComponent } from './components/incoming-referral-card/incoming-referral-card.component';
import { OutgoingReferralCardComponent } from './components/outgoing-referral-card/outgoing-referral-card.component';
import { DoctorSelectorComponent } from './components/doctor-selector/doctor-selector.component';
import { ReferralMessagesComponent } from './components/referral-messages/referral-messages.component';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    AllergyWidgetViewComponent,
    DiagnosisWidgetViewComponent,
    MedicationWidgetViewComponent,
    ProblemWidgetViewComponent,
    UploadsWidgetViewComponent,
    ClinicalNotesWidgetViewComponent,
    ProcedureWidgetViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTableModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatListModule,
    XmedicalUiModule,
    // Import standalone components
    IncomingReferralCardComponent,
    OutgoingReferralCardComponent,
    DoctorSelectorComponent,
    ReferralMessagesComponent,
    PlaybackComponent,
    MatDividerModule
  ],
  exports: [
    AllergyWidgetViewComponent,
    DiagnosisWidgetViewComponent,
    MedicationWidgetViewComponent,
    ProblemWidgetViewComponent,
    UploadsWidgetViewComponent,
    ClinicalNotesWidgetViewComponent,
    ProcedureWidgetViewComponent,
    // Export standalone components
    IncomingReferralCardComponent,
    OutgoingReferralCardComponent,
    DoctorSelectorComponent,
    ReferralMessagesComponent
  ]
})
export class XmedicalSharedModule { }
